import Privacy from "view/setting/children/use.term.privacy/privacy";
import UseTerm from "view/setting/children/use.term.privacy/use.term";

interface DataProps {
  contents: string;
}

const AgreeToModal = ({ contents }: DataProps) => {
  return <>{contents === "privacy" ? <Privacy /> : <UseTerm />}</>;
};

export default AgreeToModal;
